/**
 * Make 'campaign name' from '2022-11 - campaign name' 
*/

const getCampaignNameWithoutDate = (campaignName: string) => {
    if (!campaignName) return campaignName;
    const dateRegexp = /\d\d\d\d\-\d\d\s(\-|\|)\s/gm;
    const resCampaignName = campaignName.replaceAll(dateRegexp, '');
    return resCampaignName;
}

export default getCampaignNameWithoutDate;